export default __webpack_public_path__ + "static/media/rosco-logo-horizontal.17eb5ffa.png";